import {RequestResultValue, RequestResult, NoContentResponse, ResponseError} from "../../common/api/requestResult";
import {OrderDetailsInfo, OrderGeneralInfo, OrderListResult, OrderStatistic, OfferInfo, OfferHistoryInfo, ForceActionType, ForceOrderResponse} from "../../models/order";
import {HttpService} from "../../common/api/httpService";
import JSONbig from "json-bigint";

const JSONbigNative = JSONbig({ useNativeBigInt: true });

/** Фильтры для перехода из аналитики: причина, слова комментария (каждое должно встретиться), период создания [from; to) */
export type OrdersListExtraFilters = {
    failReason?: number;
    commentContains?: string;
    createdFrom?: Date;
    createdTo?: Date;
    /** Только заказы, на которые израсходован промокод */
    onlyWithPromoCode?: boolean;
};

export async function ordersListApi(sellerId: bigint, buyerId: bigint, botId: number, orderId: number, orderStatus: number, bidId: number, userId: bigint, page: number, count: number, gameId: number, groupFilterId: number, extra: OrdersListExtraFilters = {})
    : Promise<RequestResultValue<OrderListResult>> {
    const response = await HttpService.getInstance().requestPostAsync(`admin/orders/list`, JSONbig.stringify(
        {
            page: page,
            count: count,
            sellerId: sellerId > -1 ? sellerId : undefined,
            buyerId: buyerId > -1 ? buyerId : undefined,
            botId: botId > -1 ? botId : undefined,
            orderId: orderId > -1 ? orderId : undefined,
            status: orderStatus > -1 ? orderStatus : undefined,
            bidId: bidId > -1 ? bidId : undefined,
            userId: userId > -1 ? userId : undefined,
            gameId: gameId > -1 ? gameId : undefined,
            groupId: groupFilterId > -1 ? groupFilterId : undefined,
            failReason: extra.failReason,
            commentContains: extra.commentContains || undefined,
            createdFrom: extra.createdFrom?.toISOString(),
            createdTo: extra.createdTo?.toISOString(),
            onlyWithPromoCode: extra.onlyWithPromoCode || undefined
        }
    ));
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<OrderListResult>(true, body as OrderListResult);
    }
    return new RequestResultValue<OrderListResult>(false);
}

export async function orderGeneralInfoApi()
    : Promise<RequestResultValue<OrderGeneralInfo>> {
    const response = await HttpService.getInstance().requestGetAsync(`admin/orders/general`);
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<OrderGeneralInfo>(true, body as OrderGeneralInfo);
    }
    return new RequestResultValue<OrderGeneralInfo>(false);
}

export async function orderStatisticApi(from:Date, to:Date)
    : Promise<RequestResultValue<OrderStatistic[]>> {
    const response = await HttpService.getInstance().requestGetAsync(`admin/orders/statistic?from=${from.toISOString()}&to=${to.toISOString()}`);
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<OrderStatistic[]>(true, body as OrderStatistic[]);
    }
    return new RequestResultValue<OrderStatistic[]>(false);
}

export async function orderDetailsApi(orderId: number)
    : Promise<RequestResultValue<OrderDetailsInfo>> {
    const response = await HttpService.getInstance().requestGetAsync(`admin/orders/${orderId}/details`);
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<OrderDetailsInfo>(true, body as OrderDetailsInfo);
    }
    return new RequestResultValue<OrderDetailsInfo>(false);
}

export async function offersListApi(orderId: number)
    : Promise<RequestResultValue<OfferInfo[]>> {
    const response = await HttpService.getInstance().requestGetAsync(`admin/orders/${orderId}/offers`);
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<OfferInfo[]>(true, body as OfferInfo[]);
    }
    return new RequestResultValue<OfferInfo[]>(false);
}

export async function offersHistoryApi(offerId: number)
    : Promise<RequestResultValue<OfferHistoryInfo[]>> {
    const response = await HttpService.getInstance().requestGetAsync(`admin/orders/${offerId}/offer-history`);
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<OfferHistoryInfo[]>(true, body as OfferHistoryInfo[]);
    }
    return new RequestResultValue<OfferHistoryInfo[]>(false);
}

export async function orderForceActionApi(ids:number[], actionType: ForceActionType, reason?: string)
    : Promise<RequestResultValue<ForceOrderResponse[]>> {
    const response = await HttpService.getInstance().requestPostAsync(`admin/orders/force-action`, JSONbig.stringify(
        ids.map((id) => ({
            orderId: id,
            actionType: actionType,
            reason: reason
        }))
    ));
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<ForceOrderResponse[]>(true, body as ForceOrderResponse[]);
    }
    return new RequestResultValue<ForceOrderResponse[]>(false);
}